const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" aria-label="高雄市前金區日照中心首頁橫幅">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/f81526cefdc1f9e47204bd119708ef09.jpeg"
          alt="高雄市前金區日照中心溫馨環境 - 前金日間照顧中心舒適空間"
          title="前金日照推薦 - 溫馨舒適的長者照護環境"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-baby-blue-600/80 via-baby-blue-500/60 to-baby-blue-400/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-cream-200/90 px-5 py-2.5 rounded-full mb-6">
            <i className="ri-time-line text-baby-blue-500 text-lg" aria-hidden="true"></i>
            <span className="text-base font-medium text-baby-blue-600">週一至週五 08:00-17:00</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            <span className="sr-only">高雄市前金區日照中心 - </span>
            溫暖陪伴<br />
            <span className="text-cream-200">專業照護</span>
          </h1>

          <p className="text-xl md:text-2xl text-white/90 mb-4">
            <strong>前金日間照顧中心</strong> - 高雄市前金日照推薦首選
          </p>

          <p className="text-lg text-white/80 mb-8 max-w-lg">
            提供<strong>長照3.0</strong>專業服務，專門照顧<strong>失智</strong>及<strong>失能</strong>長者。<br />
            <strong>高雄市前金區日照中心</strong>以溫馨、專業、用心的態度，讓家屬安心、長者開心。
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToContact(); }}
              className="flex items-center gap-2 bg-cream-300 hover:bg-cream-400 text-baby-blue-600 px-8 py-4 rounded-full font-medium text-lg transition-all hover:shadow-lg cursor-pointer whitespace-nowrap"
              title="預約參觀高雄市前金區日照中心"
            >
              預約參觀
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#services"
              onClick={(e) => { e.preventDefault(); document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex items-center gap-2 bg-white/20 hover:bg-white/30 text-white px-8 py-4 rounded-full font-medium text-lg transition-all backdrop-blur-sm cursor-pointer whitespace-nowrap"
              title="了解前金日照服務項目"
            >
              了解服務
            </a>
          </div>

          <div className="flex items-center gap-8 mt-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-cream-200">30</div>
              <div className="text-base text-white/80">服務人數</div>
            </div>
            <div className="w-px h-12 bg-white/30" aria-hidden="true"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-cream-200">5</div>
              <div className="text-base text-white/80">天/週</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a 
          href="#about"
          onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }}
          className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm cursor-pointer"
          aria-label="向下捲動了解更多"
        >
          <i className="ri-arrow-down-line text-white text-xl" aria-hidden="true"></i>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
